import { ModalElementContext, ModalElementContextValue } from 'contexts/ModalProvider'
import { Context, useContext } from 'react'

function useModalElementContext<R = never>() {
  const modalElementContext = useContext<ModalElementContextValue<R>>(ModalElementContext as Context<ModalElementContextValue<R>>)
  return modalElementContext
}

export default useModalElementContext
